export const MAX_FEATURES = 6
export const RATIOS = [
  { ratio: '1/1', column: '1/2' },
  { ratio: '16/9', column: '1/-1' },
  { ratio: '2/3', column: '2/-1' },
  { ratio: '3/2', column: '1/2' },
  { ratio: '16/9', column: '1/-1' },
  { ratio: '2/3', column: '2/-1' },
]
